import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';

export const snake2camelKeys = <T>(data: T): T => {
  return camelcaseKeys(data as any, { deep: true}) as T;
}

export const camel2snakeKeys = <T>(data: T): T => {
  return snakecaseKeys(data as any, { deep: true}) as T;
}

export const snake2camel = (key: string): string => {
    return key.replace(/_([a-z])/g, (_, char) => char.toUpperCase());
};